import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, HelpCircleIcon } from 'lucide-react';
export function FAQs() {
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };
  const faqs = [{
    question: 'What should I expect during my first acupuncture visit?',
    answer: "You'll complete a detailed health history, undergo tongue and pulse diagnosis, then receive a tailored acupuncture treatment in a calm, private setting. Sessions last 60–90 minutes."
  }, {
    question: 'Is acupuncture safe for children and the elderly?',
    answer: "Yes. We adjust needle size, depth, and stimulation to each individual's age and constitution. Pediatric and geriatric protocols ensure comfort and efficacy."
  }, {
    question: 'How many sessions will I need?',
    answer: 'It varies by condition. Acute issues may resolve in 3–5 sessions; chronic or complex disorders often require 10–12 sessions, followed by maintenance treatments.'
  }, {
    question: 'Can I combine acupuncture with my current medications?',
    answer: 'Absolutely. Integrative treatment plans coordinate with conventional therapies. Always share your full medication list so we can optimize safety and outcomes.'
  }, {
    question: 'Do you offer telehealth consultations?',
    answer: 'Yes. Online integrative consultations for lifestyle, nutritional, and self-care guidance are available via secure video call.'
  }, {
    question: 'What is your cancellation policy?',
    answer: 'Please provide at least 24 hours notice to reschedule or cancel. A nominal fee applies for late cancellations or no‑shows.'
  }, {
    question: 'Are your courses accredited?',
    answer: 'Our programs are certified by national TCM and acupuncture bodies. Continuing education credits are available where applicable.'
  }, {
    question: 'How do I get course materials?',
    answer: 'Registered students receive digital manuals, slide decks, and case studies via our learning management system before course start.'
  }];
  return <div className="w-full bg-white" data-id="element-704">
      <section className="bg-gradient-to-br from-blue-50 to-teal-50 py-16 px-4 w-full" data-id="element-705">
        <div className="max-w-7xl mx-auto text-center" data-id="element-706">
          <HelpCircleIcon className="w-16 h-16 text-blue-600 mx-auto mb-6" data-id="element-707" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-708">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-709">
            Find answers to common questions about our services, treatments, and
            educational programs
          </p>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-710">
        <div className="max-w-4xl mx-auto" data-id="element-711">
          <div className="space-y-4" data-id="element-712">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-713">
                <button onClick={() => toggleFaq(index)} className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors text-left" data-id="element-714">
                  <h3 className="text-lg font-semibold text-gray-900 pr-4" data-id="element-715">
                    {faq.question}
                  </h3>
                  {expandedFaq === index ? <ChevronUpIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-716" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-717" />}
                </button>
                {expandedFaq === index && <div className="px-6 pb-6" data-id="element-718">
                    <p className="text-gray-700 leading-relaxed" data-id="element-719">
                      {faq.answer}
                    </p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gradient-to-br from-gray-50 to-blue-50 w-full" data-id="element-720">
        <div className="max-w-4xl mx-auto text-center" data-id="element-721">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-722">
            Still Have Questions?
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-723">
            Our team is here to help. Contact us for personalized assistance
            with your specific questions or concerns.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-724">
            <a href="tel:+918303699990" className="inline-flex items-center justify-center bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors" data-id="element-725">
              Call Us: +91-83036 99990
            </a>
            <a href="mailto:info@aiimr.in" className="inline-flex items-center justify-center bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-colors border-2 border-blue-600" data-id="element-726">
              Email Us
            </a>
          </div>
        </div>
      </section>
    </div>;
}